import { Center, Loader } from "@mantine/core";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useCurrentUser } from "@/lib/auth/hooks";

import { AdminShell } from "./AdminShell";

/**
 * Requires an authenticated admin session; otherwise redirects to `/login`.
 *
 * Non-admin users are sent to `/login` with `adminRequired` state so the login
 * page can surface a single "Admin access required" notification.
 */
export function ProtectedRoute() {
  const location = useLocation();
  const { data: user, isLoading, isError } = useCurrentUser();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  if (isError || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user.role !== "admin") {
    return <Navigate to="/login" replace state={{ from: location, adminRequired: true }} />;
  }

  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  );
}
